import { ApiRequest } from 'src/helpers';
import { API_END_POINTS } from 'src/constants';

export function productList() {
  return ApiRequest.fetch({
    method: 'get',
    url: `${API_END_POINTS.PRODUCTS}?slug=savvy`,
    // url: `${API_END_POINTS.PRODUCTS}`,  
  }).then((response) => ({ products: response.data.products, authCredentials: response.headers }));
}

export function createProductOffer(data) {
  return ApiRequest.fetch({
    method: 'post',
    url: API_END_POINTS.PRODUCTS_OFFERS,
    data,
  }).then((response) => response.data);
}

export function productOffersDetail({ uuid }) {
  return ApiRequest.fetch({
    method: 'get',
    url: `${API_END_POINTS.PRODUCTS_OFFERS}/${uuid}`,
  }).then((response) => response.data.productOffer);
}

export function productOffersDelete({ uuid }) {
  return ApiRequest.fetchAdmin({
    method: 'delete',
    url: `${API_END_POINTS.ADMIN_PRODUCTS_OFFERS_DELETE}/${uuid}`,
  }).then((response) => response.data);
}

export function productDetail({ uuid }) {
  return ApiRequest.fetch({
    method: 'get',
    url: `${API_END_POINTS.PRODUCTS}/${uuid}`,
  }).then((response) => response.data.product);
}
